import { render, staticRenderFns } from "./Articulos.view.vue?vue&type=template&id=1fe801a5&"
import script from "./Articulos.view.vue?vue&type=script&lang=js&"
export * from "./Articulos.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports